import { render, staticRenderFns } from "./Lobby.vue?vue&type=template&id=aca7a972&"
import script from "./Lobby.vue?vue&type=script&lang=ts&"
export * from "./Lobby.vue?vue&type=script&lang=ts&"
import style0 from "./Lobby.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports